import * as React from "react"
import { RecordPlayer } from "../../mediaPanel/recordPlayer"
import { SDKContext } from "../../../context/SDKContext"
import {
  localUserIdAtom,
  localUserNameAtom,
  remoteUsersListSelector,
  usersSelector
} from "../../../recoil/atoms/users"
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"
import {
  watchPartyHostIdSelector,
  watchPartyScreenLinkSelector,
  watchPartyScreenSelector
} from "../../../recoil/atoms/watchPartyScreen"
import { screenShareUserSelector } from "../../../recoil/atoms/screenShareUser"
import { mainWindowUserSelector } from "../../../recoil/atoms/mainWindowUser"
import { activeSpeakerSelector } from "../../../recoil/atoms/activeSpeaker"
import * as Util from "../../../util"
import LSRTCMediaConnection from "../../mediaPanel/videoPlayer/LSRTCMediaConnection"
import { rtmpStreamsAtom } from "../../../recoil/atoms/rtmpStreams"

export const Recording = () => {
  const meetingClient = React.useContext(SDKContext)
  const [localUserName] = useRecoilState(localUserNameAtom)

  React.useEffect(() => {
    if (meetingClient) {
      meetingClient?.setUserName("RECORDING_04JSF3255")
      meetingClient?.connectGateway()
    }
  }, [localUserName, meetingClient])

  const _remoteUsersList = useRecoilValue(remoteUsersListSelector)
  const watchPartySrc = useRecoilValue(watchPartyScreenLinkSelector)
  const isWatchParty = useRecoilValue(watchPartyScreenSelector)
  const watchPartyHostId = useRecoilValue(watchPartyHostIdSelector)
  const _screenShareUser = useRecoilValue(screenShareUserSelector)
  const isAudioWatchParty = React.useMemo(
    () => (watchPartySrc && watchPartySrc.endsWith(".mp3") ? true : false),
    [watchPartySrc]
  )
  const _localUserId = useRecoilValue(localUserIdAtom)
  const [_activeSpeaker, setActiveSpeaker] = useRecoilState(
    activeSpeakerSelector
  )
  const setMainWindowUser = useSetRecoilState(mainWindowUserSelector)
  const _localUser = useRecoilValue(usersSelector(_localUserId))
  const rtmpStreams = useRecoilValue(rtmpStreamsAtom)

  React.useEffect(() => {
    // _remoteUsersList doesn't include local user
    const sortedRemoteUsers = [..._remoteUsersList].sort(
      Util.previousSpeakerSorter
    )

    // Set MAIN-WINDOW-USER - START
    let mainWindowUserId = ""
    if (
      !isAudioWatchParty &&
      isWatchParty &&
      watchPartyHostId !== "modNotPresentVideo"
    ) {
      // if watchparty is enabled, sharer should be visible in small window only if his CAM/MIC is/are ON
      mainWindowUserId = "wp" + watchPartyHostId
    } else if (_screenShareUser) {
      // if screenshare is enabled, sharer should be visible in small window only if his CAM/MIC is/are ON
      mainWindowUserId = _screenShareUser.uid
    } else if (rtmpStreams.length > 0) {
      // if rtmp stream is active show it on mainWindow
      mainWindowUserId = rtmpStreams[0].uid
    } else if (isAudioWatchParty) {
      mainWindowUserId = watchPartyHostId

      if (!watchPartyHostId) {
        if (sortedRemoteUsers.length > 0) {
          mainWindowUserId = sortedRemoteUsers[0]["id"]
        } else {
          mainWindowUserId = _localUserId
        }
      }
    } else {
      if (sortedRemoteUsers.length > 0) {
        mainWindowUserId = sortedRemoteUsers[0]["id"]
      } else {
        mainWindowUserId = _localUserId
      }
    }

    // if(_activeSpeaker.uid === "" || _activeSpeaker.uid === 'undefined' || _remoteUsersList.length < 2){
    if (_activeSpeaker.uid === "" || _activeSpeaker.uid === "undefined") {
      setActiveSpeaker({ uid: mainWindowUserId })
    }

    setMainWindowUser({
      uid: mainWindowUserId
    })

    // set main window user id to be used in RTC.js
    meetingClient?.setMainWindowUserId(mainWindowUserId)
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [
    _remoteUsersList,
    isWatchParty,
    _localUser,
    _screenShareUser,
    watchPartyHostId,
    isAudioWatchParty,
    rtmpStreams
  ])

  return (
    <>
      <RecordPlayer />
      <LSRTCMediaConnection />
    </>
  )
}
